// kexin 模板静态文案: 来源类型 chips 与「可信可以帮你研究」分类问题库
export interface KexinQuestion {
  chips: string[]
  title: string
  desc: string
}

export interface KexinCategory {
  key: string
  label: string
  title: string
  subtitle: string
  questions: KexinQuestion[]
}

export const SOURCE_CHIPS = ["学术论文", "政策文件", "裁判案例", "医学指南", "官方数据"]

export const CATEGORIES: KexinCategory[] = [
  {
    key: "investment",
    label: "投资研究",
    title: "一个判断，\n如何被数据支撑？",
    subtitle: "把市场观点放回财报、公告与公开数据中验证。",
    questions: [
      {
        chips: ["财报", "行业报告", "市场数据"],
        title: "新能源车企销量增长但利润率下滑，这说明竞争力增强了，还是价格战压力加大了？",
        desc: "结合财务指标、销量结构与行业价格变化，判断增长质量与盈利压力来源。",
      },
      {
        chips: ["央行数据", "基金季报", "银行公告"],
        title: "多家银行下调存款利率，居民资金流向理财和债基，这一趋势有哪些公开数据可以验证？",
        desc: "对比资金流向、产品收益与风险等级，避免只根据短期收益做判断。",
      },
      {
        chips: ["学术论文", "指数数据", "市场研究"],
        title: "红利资产连续走强，相关研究是否支持“高股息更适合长期持有”这一判断？",
        desc: "参考长期回测与因子研究，区分策略有效性、估值变化和阶段性拥挤。",
      },
      {
        chips: ["公司公告", "产业链报告", "招投标数据"],
        title: "算力基础设施投资持续增加，哪些产业链环节可能真正受益？",
        desc: "从资本开支、订单披露和供需瓶颈出发，识别确定性与估值风险。",
      },
    ],
  },
  {
    key: "policy",
    label: "政策解读",
    title: "一项政策，\n如何改变现实？",
    subtitle: "从文件、数据和案例中判断影响，而不是只看结论。",
    questions: [
      {
        chips: ["政策文件", "官方数据", "产业规划"],
        title: "多地出台低空经济扶持政策，这些政策真正支持的是技术创新、基础设施，还是产业招商？",
        desc: "汇总政策要点与资金投向，结合产业链和落地案例，判断真实支持方向与预期效果。",
      },
      {
        chips: ["政策文件", "官方数据", "学术论文"],
        title: "数据要素政策持续落地，高校研究者应如何评估它对公共治理和产业创新的影响？",
        desc: "梳理政策演进与试点实践，分析数据流通机制、治理边界与可量化成效。",
      },
      {
        chips: ["统计数据", "政策文件", "研究报告"],
        title: "房地产政策继续优化，哪些指标能判断购房者预期是否真的发生变化？",
        desc: "结合销售、价格、信贷与预期调查等数据，评估政策对需求与市场预期的传导效果。",
      },
      {
        chips: ["政府工作报告", "财政数据", "产业规划"],
        title: "地方专项债投向发生变化，如何判断它对城市更新和产业园区建设的实际影响？",
        desc: "解析投向结构与项目清单，结合资金落地与产出数据，评估对城市与产业的带动作用。",
      },
    ],
  },
  {
    key: "law",
    label: "法律分析",
    title: "一个争议，\n如何找到依据？",
    subtitle: "把事实、法律条文和相似裁判放在同一条线索里。",
    questions: [
      {
        chips: ["裁判案例", "法律法规", "司法解释"],
        title: "公司要求员工签竞业协议但没有支付补偿，相关司法判例通常如何认定？",
        desc: "基于劳动合同法和相似裁判，梳理协议效力、补偿义务与违约责任边界。",
      },
      {
        chips: ["著作权法", "平台规则", "典型案例"],
        title: "短视频二次剪辑影视片段并获得流量收益，哪些情况下可能构成侵权？",
        desc: "结合合理使用、商业目的和替代性影响，判断内容创作中的法律风险。",
      },
      {
        chips: ["民法典", "裁判文书", "证据规则"],
        title: "朋友借钱多年不还，只有微信聊天记录和转账记录，这种情况下起诉胜算大吗？",
        desc: "梳理借贷关系成立、诉讼时效和电子证据采信中的关键判断点。",
      },
      {
        chips: ["消费者权益", "合同条款", "法院判决"],
        title: "商家写明“最终解释权归本店所有”，消费者遇到纠纷时这句话有法律效力吗？",
        desc: "对照格式条款规则与典型案例，判断商家声明能否排除消费者权利。",
      },
    ],
  },
  {
    key: "medical",
    label: "医学理解",
    title: "一个指标，\n如何读懂风险？",
    subtitle: "用指南、论文和证据等级判断医学信息的可靠程度。",
    questions: [
      {
        chips: ["医学指南", "体检标准", "权威科普"],
        title: "体检指标连续三年偏高但没有症状，应该如何根据医学指南判断是否需要进一步检查？",
        desc: "结合阈值、变化趋势和个体风险因素，区分观察、复查与进一步就医咨询。",
      },
      {
        chips: ["临床试验", "期刊论文", "指南共识"],
        title: "一项新药研究称有效率明显提高，普通读者如何判断它的样本量、对照组和证据等级？",
        desc: "拆解研究设计、终点指标和统计显著性，判断医学新闻背后的证据质量。",
      },
      {
        chips: ["循证评价", "医学会建议", "研究论文"],
        title: "癌症早筛产品越来越多，哪些筛查项目有明确证据支持，哪些可能属于过度检查？",
        desc: "对照人群适用范围和获益风险，判断筛查项目是否具有明确公共卫生价值。",
      },
      {
        chips: ["临床指南", "系统综述", "医院资料"],
        title: "同一种疾病，不同医院给出不同治疗方案，患者和家属应该如何做决策？",
        desc: "整理指南推荐、方案差异和证据等级，帮助形成可讨论的问题清单。",
      },
    ],
  },
  {
    key: "academic",
    label: "学术研究",
    title: "一个选题，\n如何变成研究？",
    subtitle: "从文献脉络、方法边界和引用规范中搭建问题。",
    questions: [
      {
        chips: ["核心期刊", "综述文章", "研究方法"],
        title: "导师认为论文选题太大，如何通过文献综述把研究问题缩小到可操作范围？",
        desc: "检索相关综述与研究空白，提供缩小问题范围的依据、方法与案例。",
      },
      {
        chips: ["原始论文", "后续研究", "同行评论"],
        title: "一篇论文引用量很高但方法存在争议，如何判断它的结论是否可靠？",
        desc: "比较研究设计、样本选择和后续验证，判断高引用结论的适用边界。",
      },
      {
        chips: ["高校规范", "期刊政策", "学术伦理"],
        title: "AI 工具参与论文写作时，哪些环节可以辅助，哪些环节可能涉及学术不端风险？",
        desc: "梳理学校和期刊规范，区分资料整理、语言润色与观点生成的风险等级。",
      },
      {
        chips: ["文献综述", "研究设计", "方法论文"],
        title: "很多论文发现变量之间存在相关性，为什么这并不等于证明了因果关系？",
        desc: "用研究设计和因果推断框架解释相关性、混杂变量和识别策略。",
      },
    ],
  },
]
